export const categoryColorMapping = {
    "Concierge": "#2D2B87",
    "Maintenance": "#0E8FD7",
    "Wellness": "#E98530",
    "Housekeeping": "#0E8FD7",
    "Spa": "#E98530",
    "Administrative": "#6BAD4C",
    "Technology": "#2D2B87",
    "Pets": "#0E8FD7",
    "Valet": "#E98530",
    "Other": "#6BAD4C",
    "Aquatics": "#6BAD4C",
    "Fitness": "#6BAD4C",
    "Mail/Packages": "#2D2B87",
    "Room": "#6BAD4C",
    "Security": "#6BAD4C",
    "Salon": "#E98530",
    "Care": "#E98530",
    "Menu": "#6BAD4C",
    "Transport": "#2D2B87",
    "Activity": "#6BAD4C",
    "Facility": "#6BAD4C",
    "Fees": "#6BAD4C",
};
